<template>
    <v-list>
        <v-list-group v-for="(item, i) in items" :key="i">
            <v-list-tile slot="item" ripple @click.native="navigate(item)">
                <v-list-tile-action>
                    <v-icon dark v-html="item.icon"></v-icon>
                </v-list-tile-action>
                <v-list-tile-title v-text="item.title"></v-list-tile-title>
                <v-list-tile-action v-if="item.items && item.items.length>0">
                    <v-icon>keyboard_arrow_down</v-icon>
                </v-list-tile-action>
            </v-list-tile>
            <v-list-tile v-for="subItem in item.items" v-bind:key="subItem.title" @click.native="navigate(subItem)">
                <v-list-tile-action>
                    <v-icon dark v-html="subItem.icon"></v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <v-icon>{{ subItem.action }}</v-icon>
                </v-list-tile-action>
            </v-list-tile>
        </v-list-group>
    </v-list>
</template>

<script>
    export default {
        data() {
            return {
                items: [{
                    icon: 'dashboard',
                    title: 'Dashboard',
                    link: '/admin/dashboard'
                },
                    {
                        icon: 'alarm_add',
                        title: 'Timesheets',
                        link: '/admin/timesheet'
                    },
                    {
                        icon: 'people',
                        title: 'Users',
                        link: '/admin/users'
                    },
                    {
                        icon: 'receipt',
                        title: 'Projects',
                        link: '/admin/projects'
                    },
                    {
                        icon: 'credit_card',
                        title: 'Reports',
                        link: '/admin/reports'
                    },
                    {
                        icon: 'people',
                        title: 'Analytics',
                        link: '/users',
                        items: [{
                            icon: 'book',
                            title: 'Users Per Projects',
                            link: '/admin/analytics/users-per-project'
                        },
                            {
                                icon: 'school',
                                title: 'Projects Per Users',
                                link: '/admin/analytics/projects-per-user'
                            }
                        ]
                    },
                ],
            }
        },
        methods: {
            navigate(item) {
                if (!item.items)
                    this.$router.push(item.link);
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/Admin/Components/SideBar.vue